// Company details shared by the UI and the prerender script (SEO metadata).

export const siteUrl = "https://xeratec.com";

export const company = {
  name: "Xeratec",
  email: "sales@xeratec.com",
  phone: {
    display: "(906) 482-6765",
    href: "tel:+19064826765",
    e164: "+1-906-482-6765",
  },
  address: {
    street: "401 Hancock Street",
    city: "Hancock",
    region: "MI",
    postalCode: "49930",
    country: "US",
  },
  mapsUrl: "https://maps.google.com/?q=401+Hancock+Street+Hancock+MI+49930",
};

/**
 * HubSpot forms behind the Contact and e-book pages: the same forms the old
 * site embedded, so leads keep landing in HubSpot (and its notifications).
 * Field names are HubSpot's internal property names.
 */
export const hubspot = {
  portalId: "8481509",
  forms: {
    contact: "a7917cb0-9459-483e-821b-593624a38584",
    ebook: "f467013e-04d0-421e-964d-2bffb32e12b1",
  },
};

/** mailto: link to the sales inbox with an optional prefilled subject/body. */
export function mailto({ subject, body } = {}) {
  const query = Object.entries({ subject, body })
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  return `mailto:${company.email}${query ? "?" + query : ""}`;
}

export const routes = {
  home: "/",
  services: "/services/",
  caseStudies: "/case-studies/",
  about: "/about-us/",
  insights: "/case-studies-2/",
  careers: "/careers/",
  contact: "/contact/",
  booking: "/book-a-meeting/",
  ebook: "/construction-companies-journey-of-digital-transformation/",
  ourStory:
    "/building-success-a-story-of-family-innovation-and-transforming-construction/",
};

/** Main navigation. "Results" is the case-study index (sales & marketing's
 * name for it); Contact lives in the footer and mobile menu. */
export const navigation = [
  { label: "Results", href: routes.caseStudies },
  { label: "Services", href: routes.services },
  { label: "About Us", href: routes.about },
  { label: "Blog", href: routes.insights },
  { label: "Careers", href: routes.careers },
];

/** Everything, for the footer and mobile menu. */
export const footerNavigation = [
  { label: "Home", href: routes.home },
  ...navigation,
  { label: "Contact", href: routes.contact },
];

/** Every booking button uses this label. */
export const bookingLabel = "Book a Meeting";

export const socialLinks = [
  { label: "Linkedin", href: "https://www.linkedin.com/company/xeratec" },
  { label: "Facebook", href: "https://www.facebook.com/Xeratec" },
  { label: "Instagram", href: "https://www.instagram.com/xeratec/" },
  { label: "Youtube", href: "https://www.youtube.com/@xera_tec" },
];

export const defaultBookingUrl =
  "https://meetings.hubspot.com/jordan-hillstrom1/project-discussion-relationship-building";

export const defaultTitle =
  "Xeratec Software Development: Web, Mobile, Backend";

/** schema.org Organization markup embedded on every prerendered page. */
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: company.name,
  url: siteUrl,
  telephone: company.phone.e164,
  email: company.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: company.address.street,
    addressLocality: company.address.city,
    addressRegion: company.address.region,
    postalCode: company.address.postalCode,
    addressCountry: company.address.country,
  },
};
